import { useGetCart } from "../queries/useCartQuery";

export const useOrderSummary = (selectedShipping = null) => {
  const { data: cartItems = [], isPending ,error} = useGetCart();
  const subtotal = cartItems.reduce(
    (acc, item) => acc + Number(item.price) * Number(item.quantity),
    0
  );

  const totalQty = cartItems.reduce(
    (acc, item) => acc + Number(item.quantity),
    0
  );

  const calculateShippingCost = () => {
    if (!selectedShipping) return 0;

    if (selectedShipping.type === "flat_cost") {
      return Number(selectedShipping.cost);
    }

    if (selectedShipping.type === "min_cost") {
      return subtotal >= Number(selectedShipping.min_cost)
        ? 0
        : Number(selectedShipping.cost);
    }

    return 0;
  };

  const shipping = calculateShippingCost();
  const tax = 0;
  const total = subtotal + shipping + tax;

  return {
    cartItems,
    isPending,
    subtotal,
    totalQty,
    shipping,
    tax,
    total,
    error
  };
};
